import { render, staticRenderFns } from "./modifyOrderDetail1.vue?vue&type=template&id=d6596170&scoped=true"
import script from "./modifyOrderDetail1.vue?vue&type=script&lang=js"
export * from "./modifyOrderDetail1.vue?vue&type=script&lang=js"
import style0 from "./modifyOrderDetail1.vue?vue&type=style&index=0&id=d6596170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6596170",
  null
  
)

export default component.exports